import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from 'antd'
import { useParams } from 'react-router-dom'
import { getAccountsDownloadFile, getAccountsDownloadStatus, getExportDataUsers } from 'src/app/shared/services/AccountService'
import { TABLE_NAME } from 'src/app/shared/constants/tableName.constants'
import { useUserForAccount } from './useUsersForAccount'
import NewCommonTable from 'src/app/shared/components/common/new-table'
import { TableColumnDefs } from 'src/app/shared/components/common/new-table/table.model'

const ViewUsersForAccount: React.FC = () => {
  const params = useParams()
  const { id } = params
  const { t } = useTranslation()
  const { userList, totalRecords, isLoading, getUserListData } = useUserForAccount()

  const handleSearch = useCallback(
    async (payload: any) => {
      await getUserListData(payload, id)
    },
    [getUserListData, id],
  )

  const generateCustomColumnDefs = useCallback(
    (colDefs: Array<TableColumnDefs>): Array<TableColumnDefs> =>
      colDefs.map((item, index) => {
        const { colId } = item
        if (colId === 'client')
          return {
            ...item,
            sortIndex: 0,
          }
        return item
      }),
    [],
  )

  return (
    <Layout.Content style={{ padding: 24 }}>
      <NewCommonTable
        tableName={t('AccountSetup:account_by_user_list.usersListForAccount')}
        total={totalRecords}
        rowData={userList}
        loading={isLoading}
        rootContainerStyle={{
          marginTop: 20,
        }}
        tableSettingName={TABLE_NAME.USERS_FOR_ACCOUNT}
        pageName={TABLE_NAME.USERS_FOR_ACCOUNT}
        displayAddBtn={false}
        displayUploadButton={false}
        displayActionColumn={false}
        autoSort={false}
        translationNamespace='AccountSetup:account_by_user_list'
        handleDownload={async (payload) => await getExportDataUsers(payload as any, id)}
        getDownloadStatus={getAccountsDownloadStatus}
        getDownloadFile={getAccountsDownloadFile}
        handleSearch={handleSearch}
        generateCustomColumnDefs={generateCustomColumnDefs}
      />
    </Layout.Content>
  )
}

export default ViewUsersForAccount
